// Utilitários do modelo "Aurora" (topo 10 · busca 13 · card 7 · rodapé 7) — gate e cores das
// seções da home (equipe, empresa, blog, canal) e das internas (/imoveis, ficha) no visual do modelo.
// Só peças do Aurora importam daqui — não é componente compartilhado dos ~300 sites.
// Helpers genéricos (contatos, menu, redes, WhatsApp, URL/foto do imóvel) são os MESMOS do
// Horizonte/Atelier, re-exportados para as peças importarem de um lugar só.
import type { CSSProperties } from 'react';
import { ensureReadableTextColor, isColorLight } from '../../../utils/FunctionsGlobals';
import { hexParaRgba } from '../horizonte/horizonte';

export { contatosDoTenant, hexParaRgba, linkWhatsApp, linkWhatsAppDoTenant, menuDoTenant, mesmaRota, misturarCores, redesDoTenant, useMovimentoReduzido } from '../horizonte/horizonte';
export type { ItemMenu, TelefoneTenant } from '../horizonte/horizonte';
export { finalidadeDoImovel, fotoOtimizada, fotosDoImovel, nomeDaEmpresa, stripHtml, tituloDoImovel, urlDaListagem, urlDoImovel } from '../atelier/atelier';

/**
 * O site está no modelo "Aurora"? A assinatura é o TOPO 10 (mesma regra do Horizonte/Atelier):
 * quem escolhe o topo 10 ganha a linguagem do modelo também nos blocos da home e nas internas —
 * sem número novo no catálogo do app. Zero diff com modelo_topo ≠ 10.
 */
export const ehModeloAurora = (site: any): boolean => Number(site?.modelo_topo) === 10;

// Curva das entradas do modelo (desacelera longo no fim) — a mesma dos modelos 8/9/10.
export const EASE_AURORA = [0.22, 1, 0.36, 1] as const;

/**
 * Variáveis CSS (--au-*) das peças do Aurora fora do carrossel, com as MESMAS contas do CardAurora:
 * fundo = cor5 (ou o fundo da seção), texto = cor11/cor13 com contraste, acento = cor2 legível sobre
 * o fundo, pílula sólida = cor2 com texto calculado. Funciona com fundo claro (cs2619) e escuro (cs1722).
 */
export const varsAurora = (site: any, fundo?: string | null): CSSProperties => {
    const corFundo = fundo || site?.cor5 || '#f6f7f9';
    const corTexto = ensureReadableTextColor(isColorLight(corFundo) ? site?.cor11 : site?.cor13, corFundo || '#ffffff') || '#1c2230';
    const corAcento = ensureReadableTextColor(site?.cor2, corFundo, 3.0, corTexto, corTexto) || corTexto;
    const corSolida = site?.cor2 || '#1c2230';
    const corSolidaTexto = ensureReadableTextColor(isColorLight(corSolida) ? site?.cor11 : site?.cor13, corSolida) || '#ffffff';
    return {
        '--au-fundo': corFundo,
        '--au-texto': corTexto,
        '--au-acento': corAcento,
        '--au-solida': corSolida,
        '--au-solida-texto': corSolidaTexto,
        '--au-sutil': hexParaRgba(corTexto, 0.12),
        '--au-sutil-forte': hexParaRgba(corTexto, 0.24),
        '--au-painel': hexParaRgba(corTexto, 0.05),
    } as CSSProperties;
};
